import apiClient from './axios';

export const listGames   = (params = {})            => apiClient.get('/games/', { params });
export const createGame  = (maxPlayers)              => apiClient.post('/games/', { max_players: maxPlayers });
export const getGame     = (id)                      => apiClient.get(`/games/${id}/`);
export const joinGame    = (id)                      => apiClient.post(`/games/${id}/join/`);
export const leaveGame   = (id)                      => apiClient.post(`/games/${id}/leave/`);
export const readyUp     = (id)                      => apiClient.post(`/games/${id}/ready/`);
export const startGame   = (id)                      => apiClient.post(`/games/${id}/start/`);
export const getGameState= (id)                      => apiClient.get(`/games/${id}/state/`);

export const performAction = (id, type, payload, stateVersion) =>
  apiClient.post(`/games/${id}/action/`, { type, payload, state_version: stateVersion });

export const chooseNoble = (id, nobleId, stateVersion) =>
  apiClient.post(`/games/${id}/choose_noble/`, { noble_id: nobleId, state_version: stateVersion });
